import { Swiper, SwiperSlide } from 'swiper/react';
import { Keyboard, Navigation, Pagination } from 'swiper/modules';
import { useCallback, useRef, useState } from 'react';
import { FaStar, FaHeart } from 'react-icons/fa';
import IconHeader from 'src/components/molecules/IconHeader';
import { BiChevronRightCircle, BiChevronLeftCircle } from 'react-icons/bi';
import Text from 'src/models/Text';
import ListItem from '../templates/EventsList/ListItem';

const FeaturedEventsSlider = ({
  featuredEvents,
  loadAllFeatured,
  featuredEventsFullyLoaded,
  publisherSettings,
  heading,
}) => {
  const sliderRef = useRef(null);
  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  const [showNext, setShowNext] = useState(true);
  const [showPrev, setShowPrev] = useState(false);
  const text = new Text(publisherSettings);

  const showSlider = featuredEvents.length > 4;

  return (
    <div className="mb-6 relative">
      <div>
        <IconHeader
          icon={
            heading === 'editors_pick_heading_text' ? (
              <FaHeart className="p-0.5" />
            ) : (
              <FaStar />
            )
          }
          text={text.for(heading)}
        />
      </div>
      <div className={showSlider ? 'px-3' : ''}>
        <Swiper
          slidesPerView={featuredEvents.length > 1 ? 1.2 : 1}
          ref={sliderRef}
          spaceBetween={16}
          keyboard={{
            enabled: true,
          }}
          grabCursor={true}
          modules={[Keyboard, Pagination, Navigation]}
          className="mySwiper"
          onReachEnd={() => {
            if (!featuredEventsFullyLoaded) {
              return;
            }
            setTimeout(() => {
              setShowNext(false);
            }, 100);
          }}
          onReachBeginning={() =>
            setTimeout(() => {
              setShowPrev(false);
            }, 100)
          }
          onSlideChange={() => {
            loadAllFeatured();
            setShowNext(true);
            setShowPrev(true);
          }}
          breakpoints={{
            640: {
              slidesPerView: featuredEvents.length > 2 ? 2.2 : 2,
            },
            768: {
              slidesPerView: 3,
            },
            // 1280 - 40 padding = 1240
            1240: {
              slidesPerView: 4,
            },
          }}
          // TODO: Switch from the custom swiper build to the official one once it's released
          breakpointsBase="container"
          cssMode={true}
        >
          {featuredEvents.map((event, index) => (
            <SwiperSlide key={index}>
              <div className="">
                <ListItem
                  key={event.id}
                  event={event}
                  featuredPosition
                  isFeatured={event.isFeatured(publisherSettings.publisher.id)}
                  isEditorsPick={event.isEditorsPick(publisherSettings.publisher.id)}
                  viewedFrom="featured"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        {showSlider && (
          <>
            <div
              onClick={handlePrev}
              className={`${
                showPrev ? '' : 'hidden'
              } cursor-pointer absolute left-0 z-10 top-1/2 -ml-0.5`}
            >
              <BiChevronLeftCircle
                className="w-10 h-10 text-gray-500 bg-white opacity-80 hover:opacity-100"
                style={{ borderRadius: '100%' }}
              />
            </div>
            <div
              onClick={handleNext}
              className={`${
                showNext ? '' : 'hidden'
              } cursor-pointer absolute right-0 z-10 top-1/2 -mr-0.5`}
            >
              <BiChevronRightCircle
                className="w-10 h-10 text-gray-500 bg-white opacity-80 hover:opacity-100"
                style={{ borderRadius: '100%' }}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default FeaturedEventsSlider;
